import { render, staticRenderFns } from "./LockedUsersPage.vue?vue&type=template&id=0f9c1237&scoped=true"
import script from "./LockedUsersPage.vue?vue&type=script&lang=ts"
export * from "./LockedUsersPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c1237",
  null
  
)

export default component.exports